import * as React from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { T } from "../T";

type FaqQuestionProps = {
  question: string;
  answer: string;
};
const FaqQuestion = ({ question, answer }: FaqQuestionProps) => {
  return (
    <Accordion
      disableGutters
      sx={{
        "&.Mui-expanded": {
          margin: 0,
        },
      }}
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography
          variant="body1"
          sx={{
            color: "primary.contrastText",
            fontWeight: "bold",
          }}
        >
          <T str={question} />
        </Typography>
      </AccordionSummary>
      <AccordionDetails
        sx={{
          bgcolor: "background.paper",
        }}
      >
        <T str={answer} />
      </AccordionDetails>
    </Accordion>
  );
};

export default FaqQuestion;
